import { SeoInsightsContentV2 } from "@/components/seo-insights/SeoInsightsContentV2";

export interface SeoKeyword {
  id: number;
  search: string;
  search_volume: number;
  kps_raw: number;
  hero_relevance: number;
}

export interface PublicSeoInsightsPayload {
  topPriority: SeoKeyword[];
  hiddenGems: SeoKeyword[];
  trending: SeoKeyword[];
  aiRecs: { keyword: string; note: string; kps: number }[];
  summary: {
    keywordsAnalyzed: number;
    topPriorityCount: number;
    hiddenGemsCount: number;
    trendingCount: number;
  };
}

interface PublicSeoInsightsViewProps {
  payload: PublicSeoInsightsPayload;
}

export function PublicSeoInsightsView({ payload }: PublicSeoInsightsViewProps) {
  return <SeoInsightsContentV2 isPublic publicData={payload} />;
}
